import { Slot } from '@radix-ui/react-slot';

import { useScrollContext, type ElementProps } from '.';

export function Element<T extends string>(elementProps: ElementProps<T>) {
  const { name, asChild = false, ...props } = elementProps;
  const { setSectionRef } = useScrollContext();

  const Comp = asChild ? Slot : 'div';

  return <Comp data-slot={'scroll-element-' + name} ref={setSectionRef(name)} {...props} />;
}
